import { Button, Modal, Stack, Text } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import type { SpreadPlacedCardView } from '@creativitas/shared';
import { PlayingCard } from '@/components/domain/PlayingCard';
import { atTier } from '@/lib/assets';

type CardPreviewModalProps = {
  card: SpreadPlacedCardView | null;
  onClose: () => void;
  onRemove?: (cardId: string) => void;
  busy?: boolean;
};

/** Enlarged inspection of one card lying on the table. */
export function CardPreviewModal({ card, onClose, onRemove, busy }: CardPreviewModalProps) {
  return (
    <Modal opened={Boolean(card)} onClose={onClose} title={card?.deckTitle ?? 'Карта'} size="md">
      {card ? (
        <Stack align="center" gap="md">
          <PlayingCard
            frontImage={card.card.frontImage ? atTier(card.card.frontImage, 'cardFull') : null}
            backImage={card.card.backImage}
            faceUp={card.revealed}
            label={card.card.title ?? `Карта ${card.card.position}`}
            width={280}
          />
          <Text size="sm" c="var(--text-muted)">
            {card.card.title ?? `${card.deckTitle} · карта ${card.card.position}`}
          </Text>

          {onRemove ? (
            <Button
              variant="light"
              color="red"
              leftSection={<IconTrash size={16} />}
              disabled={busy}
              onClick={() => onRemove(card.id)}
            >
              Убрать со стола
            </Button>
          ) : null}
        </Stack>
      ) : null}
    </Modal>
  );
}
